module.exports = new Promise((resolve) => {
                const script = document.createElement('script');
                script.src =  window.__WKD_REMOTE_JS_MAP__.common;
                script.onload = () => {
                  // the injected script has loaded and is available on window
                  // we can now resolve this Promise
                  const proxy = {
                    get: (request) => window.wkdCommon.get(request),
                    init: (arg) => {
                      try {
                        return window.wkdCommon.init(arg);
                      } catch (e) {
                        console.log('remote container already initialized');
                      }
                    },
                  };
                  resolve(proxy);
                };
                // inject this script with the src set to the versioned remoteEntry.js
                document.head.appendChild(script);
              });